var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-flix-button',{attrs:{"variant":"contained-green","callback":_vm.setSave}},[_c('b-flix-icon',{attrs:{"icon":"circle-check"}}),_vm._v(" Jetzt speichern")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }